// extracted by mini-css-extract-plugin
export default {"breakLongText":"breakLongText---CxFIt"};